import React from "react";
import PropTypes from "prop-types";
import P24NavBar from "./P24NavBar";

/**
 * Zawartość prywatnych stron z nawigacją P24
 * 
 * @param {String} className bazowa nazwa klasy css
 * @param {node} children dziedzi komponentu
 */
const P24MainContent = ({ className, children }) => {
  return (
    <main className={className}>
      <P24NavBar />
      <div className="w3-padding-large">
        {children}
      </div>
    </main>
  )
}

P24MainContent.propTypes = {
  //bazowa klasa css
  className: PropTypes.string,
  //dzieci komponentu / zawartosc glownej strony
  children: PropTypes.node.isRequired
};

export default P24MainContent;
